import { TFunction } from 'i18next'

import { processPipelineStatus } from 'utils/constantFilter'
import { coreApi } from '../api'

interface CadenceAPI {
  currentNumber: number
  successfulContact: boolean
}

interface ApplicationAPI {
  applicationId: string
  scheduling: string
  cadence: CadenceAPI
}

interface TasksAPI {
  docsDoneTasksQuantity: number
  docsTasksQuantity: number
  pipelineStatus: string
  incompleteTaskOrder: number
}

interface RequesterAPI {
  fullName: string
  cpf: string
}

interface AssignmentAPI {
  date: string
  reason: string
}

interface WorkflowAPI {
  application: ApplicationAPI
  tasks: TasksAPI
  assignment: AssignmentAPI
  requester: RequesterAPI
}

const meta: MetaData = {
  page: 1,
  totalpages: 1,
}

function formatCpf(t: TFunction, cpf: string): string {
  return t('table.body.cpf', { cpf })
}

async function fetchData(
  t: TFunction,
): Promise<{ data: Workflow[]; meta: MetaData }> {
  const response = await coreApi.get(
    '/sales-engagement/auto-refi/assignments/workflow-details',
  )
  const { data } = response.data

  return {
    data: data.map(function trasnformWorkflowAPI({
      assignment: { date: assignmentDate },
      application: {
        applicationId,
        scheduling,
        cadence: { currentNumber, successfulContact },
      },
      tasks: {
        docsDoneTasksQuantity,
        docsTasksQuantity,
        pipelineStatus,
        incompleteTaskOrder,
      },
      assignment: { reason },
      requester: { fullName, cpf },
    }: WorkflowAPI): Workflow {
      return {
        cpf: formatCpf(t, cpf),
        docs: `${docsDoneTasksQuantity}/${docsTasksQuantity}`,
        fullName,
        id: applicationId,
        pipelineStatus: processPipelineStatus(
          t,
          pipelineStatus,
          incompleteTaskOrder,
        ),
        scheduling,
        hasPendency: reason === 'pendency',
        assignmentDate: assignmentDate ? new Date(assignmentDate) : null,
        cadence:
          currentNumber < 0 || successfulContact
            ? '-'
            : currentNumber.toString(),
        successfulContact,
      }
    }),
    meta,
  }
}

export { fetchData }
